import { Observable } from 'rxjs';
import { HttpClient, ListParams } from './http-client';
import Paginate from '../interfaces/paginate';
import Article from '../interfaces/article';

export class ArticleService extends HttpClient {
  public(page = 1): Observable<Paginate<Article>> {
    return this.get<Paginate<Article>>(`/api/articles/public`, { page });
  }

  publicShow(id: string): Observable<Article> {
    return this.get<Article>(`/api/articles/public/${id}`);
  }

  index(params: ListParams): Observable<Paginate<Article>> {
    return this.get<Paginate<Article>>('/api/internal/articles', params);
  }

  store(article: Article): Observable<Article> {
    return this.post<Article>(`/api/internal/articles`, article);
  }

  show(id: string): Observable<Article> {
    return this.get<Article>(`/api/internal/articles/${id}`);
  }

  update(id: string, article: Article): Observable<Article> {
    return this.put<Article>(`/api/internal/articles/${id}`, article);
  }
}
